module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture31-5aa5745b5ffdf6566a5f1077e885ca7c.jpg";